export const ECHOES_VIDEOS = [
    {
        id: 1,
        title: 'Trailer',
        source: require('../videos/echoes/echoesTrailer.mp4')
    },
    {
        id: 2,
        title: "Build",
        source: require("../videos/echoes/echoesbuilding.mp4")
    },
    {
        id: 3,
        title: "Grind",
        source: require("../videos/echoes/echoesgrind.mp4")
    },
];

export const HYPERBAWL_VIDEOS = [
    {
        id: 1,
        title: 'Trailer',
        source: require('../videos/hyperbawl/HyperbawlTrailer.mp4')
    },
    {
        id: 2,
        title: "Map",
        source: require("../videos/hyperbawl/MapHyperbawl.mp4")
    },
    {
        id: 3,
        title: "Player",
        source: require("../videos/hyperbawl/PersoHyperbawl.mp4")
    },
    {
        id: 4,
        title: "Reseau",
        source: require("../videos/hyperbawl/Reseau.mp4")
    },
];

export const KIRA_VIDEOS = [
    {
        id: 1,
        title: 'Trailer',
        source: require('../videos/kira/kiraTrailer.mp4')
    },
    {
        id: 2,
        title: "Compétences",
        source: require("../videos/kira/competences.mp4")
    },
]